import { LITANY_OF_LORETO as litany } from "@/data/litanyOfLoreto";

const Invocation = ({ text, response, testId }) => (
  <li className="flex flex-wrap gap-x-2 gap-y-0.5" data-testid={testId}>
    <span data-testid={`${testId}-invocation`}>{text}</span>
    <span className="font-semibold italic text-marian" data-testid={`${testId}-response`}>{response}</span>
  </li>
);

export const LitanyText = () => (
  <div className="max-w-3xl space-y-7 break-words font-serif text-base leading-relaxed text-midnight sm:text-lg" lang="en" data-testid="litany-full-text">
    <p className="whitespace-pre-line" data-testid="litany-opening">{litany.opening.join("\n")}</p>
    <ul className="space-y-2" data-testid="litany-trinity">
      {litany.trinity.map((line, i) => <Invocation key={line} text={`${line},`} response="have mercy on us." testId={`litany-trinity-${i + 1}`} />)}
    </ul>
    <ul className="space-y-2" data-testid="litany-marian-invocations">
      {litany.invocations.map((line, i) => <Invocation key={line} text={`${line}${i === litany.invocations.length - 1 ? "." : ","}`} response="pray for us." testId={`litany-marian-${i + 1}`} />)}
    </ul>
    <ul className="space-y-3" data-testid="litany-lamb-petitions">
      {litany.lambResponses.map((response, i) => <Invocation key={response} text={litany.lambInvocation} response={response} testId={`litany-lamb-${i + 1}`} />)}
    </ul>
    <div data-testid="litany-closing-versicle">
      <p>{litany.versicle}</p><p className="font-semibold italic text-marian">{litany.versicleResponse}</p>
    </div>
    <p className="whitespace-pre-line" data-testid="litany-collect">{litany.collect}</p>
  </div>
);